import React, {useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import './Register.css';
import { useConfig } from './ConfigContext';

const Register = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [pin, setPin] = useState('');
    const [error, setError] = useState('');
    const [userServiceUrl, setUserServiceUrl] = useState(null);
    const navigate = useNavigate();
    const config = useConfig();

    useEffect(() => {
        if (config) {
            setUserServiceUrl(config["user_service_url"]);
        }
    }, [config]);

    const handleRegister = async (event) => {
        event.preventDefault();
        try {
            const formData = new FormData();
            formData.append('email', email);
            formData.append('password', password);
            formData.append('pin', pin);

            const response = await fetch(userServiceUrl + '/register', {
                method: 'POST',
                body: formData,
            });

            if (response.ok) {
                navigate('/login');
            } else {
                const errorData = await response.json();
                setError(errorData.message);
            }
        } catch (error) {
            setError('An error occurred during login.');
            console.error('Error:', error);
        }

    };

    const navigateToLogin = () => {
        navigate('/login');
    };

    return (
        <div className="register-container">
            <h1>Register</h1>
            <form onSubmit={handleRegister}>
                <div>
                    <label>Email:</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <label>Password:</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <label>Pin:</label>
                    <input
                        type="pin"
                        value={pin}
                        onChange={(e) => setPin(e.target.value)}
                        required
                    />
                </div>
                <button type="submit">Register</button>
            </form>
            <button onClick={navigateToLogin}>Back to Login</button>
            {error && <div className="error">{error}</div>}
        </div>
    );
};

export default Register;
